// extracted by mini-css-extract-plugin
export default {"dropdown_items_wrapper":"AccountSection_dropdown_items_wrapper__ZbXOt","show":"AccountSection_show__uC8tu"};